module.exports = __webpack_public_path__ + "static/media/KYABRS.96bc4ebc.png";